import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import RawdemandDashboard from '../RawdemandDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function RawdemandPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < RawdemandDashboard />
    )

}